<template>
  <v-container>
    <v-alert
      :type="alertType"
      transition="scale-transition"
      v-model="alertBox"
      border="left"
      dismissible
      >{{ alertMsg }}</v-alert
    >
    <v-form v-model="formReady">
      <v-row justify="space-around" align="center">
        <v-col class="text-center" cols="12" sm="6" lg="6">
          <v-text-field
            :rules="[rules.required]"
            label="Hostname"
            v-model="mqttHostname"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" lg="2">
          <v-text-field
            :rules="[rules.required]"
            label="Port"
            v-model="mqttPort"
          ></v-text-field>
        </v-col>

        <v-col cols="6" sm="2" lg="2">
          <v-checkbox v-model="checkboxIsTLS" :label="`TLS`"></v-checkbox>
        </v-col>

        <v-col cols="6" sm="2" lg="2">
          <v-checkbox
            v-model="checkboxCheckCertificate"
            :label="`Validate Certificate`"
          ></v-checkbox>
        </v-col>
        <v-col class="text-center" cols="12" sm="6" lg="6">
          <v-text-field
            :rules="[rules.required]"
            label="Username"
            v-model="mqttUsername"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" lg="6">
          <v-text-field
            :rules="[rules.required]"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            label="Password"
            v-model="mqttPassword"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" lg="6">
          <v-row align="center">
            <v-col class="text-right">
              <v-text-field
                :rules="[rules.required]"
                label="Topic"
                v-model="mqttTopic"
              ></v-text-field>
            </v-col>
            <v-col class="text-left">
              <v-checkbox v-model="mqttRegex" label="Use regex ?"></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" lg="6">
          <v-row align="center">
            <v-col class="text-right">
              <v-jsoneditor
                style="z-index: 1"
                v-model="testJson"
                :plus="false"
                :options="{ mode: 'code', enableTransform: false }"
                :height="'250px'"
              ></v-jsoneditor>
            </v-col>
            <v-col class="text-left">
              <p>TestJson :</p>
              <vue-json-pretty :data="testJson"></vue-json-pretty>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <codeInput :code="deviceTypeMqtt.function" @newCode="newCode"></codeInput>
      <v-row>
        <v-col class="text-center">
          <v-btn
            class="ma-2"
            tile
            outlined
            color="primary"
            @click="$emit('back')"
          >
            <v-icon left>mdi-arrow-left</v-icon>
            {{ $t("DeviceTypes.back") }}
          </v-btn>
        </v-col>
        <v-col v-if="deviceTypeMqtt.url != undefined" class="text-center">
          <v-btn class="ma-2" tile outlined color="primary" @click="deleteMqtt">
            <v-icon left>mdi-delete</v-icon>
            {{ $t("DeviceTypes.delete") }}
          </v-btn>
        </v-col>
        <v-col class="text-center">
          <v-btn class="ma-2" tile outlined color="primary" @click="save">
            <v-icon left>mdi-arrow-left</v-icon>
            {{ $t("DeviceTypes.save") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import CodeInputComponent from "./CodeInput";
import VJsoneditor from "v-jsoneditor/src/index";
import VueJsonPretty from "vue-json-pretty";

import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  components: {
    codeInput: CodeInputComponent,
    VJsoneditor,
    VueJsonPretty,
  },
  props: {
    choosenDeviceType: Object,
    deviceTypeMqtt: Object,
    path: String,
  },
  data() {
    return {
      mqttUsername: "",
      mqttHostname: "",
      mqttPort: 0,
      mqttTopic: "",
      mqttPassword: "",
      mqttRegex: false,
      alertType: "error",
      alertMsg: "",
      alertBox: false,
      code: "",
      testJson: {},
      show1: false,
      formReady: false,
      checkboxIsTLS: false,
      checkboxCheckCertificate: false,
      rules: {
        required: (value) =>
          !!value || this.$t("Login.RegisterComponent.rules.required"),
      },
    };
  },
  computed: {
    readyToSave: function () {
      if (
        this.formReady &&
        !(
          Object.keys(this.testJson).length === 0 &&
          this.testJson.constructor === Object
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    deleteMqtt() {
      axios
        .delete(
          process.env.VUE_APP_API_ADDR +
            "/api/devicetype/" +
            this.choosenDeviceType.deviceTypeId +
            "/mqtt",
          {
            headers: {
              Authorization: tokenStore.getToken(),
            },
            data: {
              username: this.deviceTypeMqtt.username,
              url: this.deviceTypeMqtt.url,
              port: this.deviceTypeMqtt.port,
              topic: this.deviceTypeMqtt.topic,
              isTLS:this.deviceTypeMqtt.isTLS,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.$emit("saved", "Alert mqtt connection removed !");
          }
        })
        .catch((err) => {
          if (err) {
            console.log(err);
            this.alertType = "error";
            this.alertMsg = err.response.data.errorMessage;
            this.alertBox = true;
            window.scrollTo(0, 0);
          }
        });
    },
    newCode(value) {
      this.code = value;
    },
    save: function () {
      if (this.readyToSave) {
        if (this.path == "updateMqtt") {
          axios
            .put(
              process.env.VUE_APP_API_ADDR +
                "/api/devicetype/" +
                this.choosenDeviceType.deviceTypeId +
                "/mqtt",
              {
                username: this.deviceTypeMqtt.username,
                password: this.mqttPassword,
                isTLS: this.checkboxIsTLS,
                checkCertificate: this.checkboxCheckCertificate,
                url: this.deviceTypeMqtt.url,
                port: this.deviceTypeMqtt.port,
                topic: this.deviceTypeMqtt.topic,
                regex: this.mqttRegex,
                newUsername: this.mqttUsername,
                newUrl: this.mqttHostname,
                newPort: this.mqttPort,
                newTopic: this.mqttTopic,
                newFunction: this.code,
                testJson: this.testJson,
              },
              {
                headers: { Authorization: tokenStore.getToken() },
              }
            )
            .then(() => {
              this.$emit("saved", "Alert mqtt connection created !");
            })
            .catch((err) => {
              console.log(err);
              this.alertType = "error";
              this.alertMsg = err.response.data.errorMessage;
              this.alertBox = true;
              window.scrollTo(0, 0);
            });
        } else if (this.path == "createMqtt") {
          axios
            .post(
              process.env.VUE_APP_API_ADDR +
                "/api/devicetype/" +
                this.choosenDeviceType.deviceTypeId +
                "/mqtt",
              {
                password: this.mqttPassword,
                regex: this.mqttRegex,
                username: this.mqttUsername,
                url: this.mqttHostname,
                port: this.mqttPort,
                topic: this.mqttTopic,
                function: this.code,
                testJson: this.testJson,
                isTLS: this.checkboxIsTLS,
                checkCertificate: this.checkboxCheckCertificate
              },
              {
                headers: { Authorization: tokenStore.getToken() },
              }
            )
            .then(() => {
              this.$emit("saved", "Alert mqtt connection created !");
            })
            .catch((err) => {
              console.log(err);
              console.log(err.response.data);
              this.alertType = "error";
              this.alertMsg = err.response.data.errorMessage;
              this.alertBox = true;
              window.scrollTo(0, 0);
            });
        }
      } else {
        this.alertType = "error";
        this.alertMsg = this.$t("Complete correctly the form");
        this.alertBox = true;
        window.scrollTo(0, 0);
      }
    },
  },
  beforeMount() {
    if (this.path == "updateMqtt") {
      this.mqttHostname = this.deviceTypeMqtt.url;
      this.mqttPort = this.deviceTypeMqtt.port;
      this.mqttUsername = this.deviceTypeMqtt.username;
      this.mqttTopic = this.deviceTypeMqtt.topic;
      this.mqttRegex = this.deviceTypeMqtt.regex;
      this.testJson = this.deviceTypeMqtt.testJson;
      this.checkboxIsTLS = this.deviceTypeMqtt.isTLS;
      this.checkboxCheckCertificate = this.deviceTypeMqtt.checkCertificate;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>